import { ColumnDef } from "@tanstack/react-table";
import { User } from "models/User";
import { Ellipsis, Edit, Trash2 } from "lucide-react";
import { Dropdown } from "components";
import { AuthenticationService } from "authentication/AuthenticationService";

/**
 * Team DataTable Columns
 * ----------------
 * The column definitions for the team table.
 */

// Column definitions for the team table
export const TeamColumns = (
  onEdit: (user: User) => void,
  onDelete: (user: User) => void
): ColumnDef<User>[] => {
  const isAdmin = AuthenticationService.isAdminLikeRole();

  return [
    {
      accessorKey: "firstName",
      header: "Name",
      enableSorting: true,
      cell: ({ row }) => {
        const user = row.original;
        const fullName = `${user.firstName || ""} ${
          user.lastName || ""
        }`.trim();
        const initials = fullName
          .split(" ")
          .map((n) => n[0])
          .join("")
          .toUpperCase();

        return (
          <div className="flex items-center space-x-3">
            <div className="h-10 w-10 rounded-full bg-purple-100 flex items-center justify-center">
              <span className="text-sm font-medium text-purple-700">
                {initials}
              </span>
            </div>
            <div>
              <div className="font-medium text-gray-900">{fullName}</div>
              <div className="text-sm text-gray-500">{user.email}</div>
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: "email",
      header: "Email",
      enableSorting: true,
      cell: ({ row }) => (
        <div className="text-gray-600">{row.getValue("email")}</div>
      ),
    },
    {
      accessorKey: "role",
      header: "Role",
      enableSorting: true,
      cell: ({ row }) => {
        const user = row.original;
        return <div className="font-medium text-gray-900">{user.role}</div>;
      },
    },

    {
      accessorKey: "actions",
      header: "",
      enableSorting: false,
      cell: ({ row }) =>
        isAdmin && (
          <div className="text-gray-600 flex justify-end">
            <Dropdown
              trigger={
                <button className="flex items-center justify-center rounded-md hover:bg-gray-100 w-[30px] h-[30px]">
                  <Ellipsis className="w-4 h-4" />
                </button>
              }
              items={[
                {
                  label: "Edit",
                  icon: Edit,
                  onClick: () => onEdit(row.original),
                },
                {
                  label: "Delete",
                  icon: Trash2,
                  onClick: () => onDelete(row.original),
                },
              ]}
            />
          </div>
        ),
    },
  ];
};
